import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc AddInsuranceDiscountCardTodo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AddInsuranceDiscountCardTodoService } from 'services/addInsuranceDiscountCardTodo';
 *
 * // create service instance and send/cancel request
 * const addInsuranceDiscountCardTodoService = new AddInsuranceDiscountCardTodoService();
 * const result = await addInsuranceDiscountCardTodoService.fetchData( '<user-id>' ); // fetch data
 * addInsuranceDiscountCardTodoService.cancel(); // cancel an active request
 */
export class AddInsuranceDiscountCardTodoService extends HttpService {

    // try submittig form data and send back response
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
